import { getAccessTokenApi } from './auth';
import { getCurrentSubdomain } from './tenantResolver';

// Cabeceras para los <Upload action="..."> de antd. Esos componentes suben con XHR propio y no
// pasan por el interceptor de axios, así que sin esto la petición viaja sin sesión.
export const getUploadHeaders = () => {
  const headers = {};
  const token = getAccessTokenApi();
  if (token) headers.Authorization = token;
  const subdomain = getCurrentSubdomain();
  if (subdomain) headers['X-Tenant-Subdomain'] = subdomain;
  return headers;
};
